
  var _styles = {
  "binding-rule-modal__wrapper": {
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "binding-rule-modal__content-wrapper": {
    "width": "8rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.42667rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "overflow": "hidden",
    "position": "relative",
    "height": "11.93333rem"
  },
  "binding-rule-modal__header-image": {
    "width": "8rem"
  },
  "binding-rule-modal__title": {
    "marginTop": "0.32rem",
    "marginBottom": "0.10667rem",
    "fontSize": "0.45333rem",
    "lineHeight": "0.82667rem",
    "fontWeight": "600",
    "color": "rgb(26,26,26)",
    "fontFamily": "PingFang SC",
    "textAlign": "center"
  },
  "binding-rule-modal__content-wrapper-inner": {
    "width": "8rem",
    "height": "11.93333rem",
    "position": "relative"
  },
  "binding-rule-modal__list-wrapper": {
    "width": "8rem",
    "height": "8.93333rem",
    "position": "relative"
  },
  "binding-rule-modal__scroll-content": {
    "width": "8rem",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "justifyContent": "flex-start",
    "paddingLeft": "0.42667rem",
    "paddingRight": "0.42667rem"
  },
  "binding-rule-modal__rule-text": {
    "fontSize": "0.37333rem",
    "lineHeight": "0.66667rem",
    "color": "rgb(102,102,102)",
    "fontFamily": "PingFang SC"
  },
  "binding-rule-modal__scroll-footer": {
    "width": "8rem",
    "height": "1.33333rem"
  },
  "binding-rule-modal__bottom-gradient": {
    "position": "absolute",
    "bottom": 0,
    "width": "8rem",
    "height": "1.6rem"
  },
  "binding-rule-modal__confirm-btn": {
    "position": "relative",
    "overflow": "hidden",
    "width": "7.14667rem",
    "height": "1.17333rem",
    "borderRadius": "0.58667rem",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "marginTop": "0.32rem",
    "marginBottom": "0.42667rem"
  },
  "binding-rule-modal__confirm-btn-gradient": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "100%",
    "height": "100%",
    "borderRadius": "0.58667rem",
    "zIndex": 0
  },
  "binding-rule-modal__confirm-btn-text": {
    "position": "relative",
    "zIndex": 1,
    "fontSize": "0.42667rem",
    "lineHeight": "0.77333rem",
    "fontWeight": "600",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC"
  },
  "cfe-five-city-close-button": {
    "marginTop": "0.70667rem"
  },
  "cfe-five-city-close-button-img": {
    "width": "0.64rem",
    "height": "0.64rem"
  }
};



  module.exports = _styles;
  